export enum SlotSetup {
  whole_day = 'whole_day',
  half_day = 'half_day',
  minutes = 'minutes',
}
